/** Анимирует числовое значение статистической карточки. */
export const useStatisticCounter = (getValue: () => number) => {
  const digitValue = ref(0)
  let animationFrameId: number | undefined

  const animate = (initValue: number, lastValue: number, duration: number) => {
    if (import.meta.server) return

    let startTime = 0

    const step = (currentTime: number) => {
      if (!startTime) startTime = currentTime

      const progress = Math.min((currentTime - startTime) / duration, 1)
      digitValue.value = Math.floor(
        progress * (lastValue - initValue) + initValue,
      )

      if (progress < 1) {
        animationFrameId = window.requestAnimationFrame(step)
      }
    }

    if (animationFrameId) window.cancelAnimationFrame(animationFrameId)
    animationFrameId = window.requestAnimationFrame(step)
  }

  onBeforeUnmount(() => {
    if (animationFrameId) window.cancelAnimationFrame(animationFrameId)
  })

  watch(getValue, (newValue) => animate(digitValue.value, newValue, 2000), {
    immediate: true,
  })

  return { digitValue }
}
